const actions = {
  SET_STATE: 'user/SET_STATE',
  LOGIN: 'user/LOGIN',
  LOGIN_OTP: 'user/LOGIN_OTP',
  LOGIN_TOKEN: 'user/LOGIN_TOKEN',
  SIGN_UP: 'user/SIGN_UP',
  REQUEST_RESET_PASSWORD_EMAIL: 'user/REQUEST_RESET_PASSWORD_EMAIL',
  RESET_PASSWORD: 'user/RESET_PASSWORD',
  TEAM_COLLABORATOR_ACCEPT_INVITE: 'user/TEAM_COLLABORATOR_ACCEPT_INVITE',
  GOOGLE_LOGIN: 'user/GOOGLE_LOGIN',
  UPDATE_USER_PROFILE: 'user/UPDATE_USER_PROFILE',
  CUSTOMER_SWITCHED_DASHBOARD: 'user/CUSTOMER_SWITCHED_DASHBOARD',
  BETA_CUSTOMER_UPDATE: 'user/BETA_CUSTOMER_UPDATE',
  UPDATE_2FA_ACCOUNT_STATUS: 'user/UPDATE_2FA_ACCOUNT_STATUS',
  SHOW_USER_FEEBACK: 'user/SHOW_USER_FEEBACK',
  ONBOARDING_STEP2: 'user/ONBOARDING_STEP2',
  LOAD_CURRENT_ACCOUNT: 'user/LOAD_CURRENT_ACCOUNT',
  LOGOUT: 'user/LOGOUT',
  GET_BILLING_DATA: 'user/GET_BILLING_DATA',
  CHECK_CARD_STATUS_ACTION: 'user/CHECK_CARD_STATUS_ACTION',
  CHECK_CARD_STATUS: 'user/CHECK_CARD_STATUS',
  LOGIN_WITH_GITHUB: 'user/LOGIN_WITH_GITHUB',
  LOGIN_WITH_GOOGLE: 'user/LOGIN_WITH_GOOGLE',
  BETA_CUSTOMER_CHECK: 'user/BETA_CUSTOMER_CHECK',
  AUTHENTICATE_IF_USER_ALREADY_IN_SESSION: 'user/AUTHENTICATE_IF_USER_ALREADY_IN_SESSION',
  UPDATE_CUSTOMER_CHOICE_OF_APPS_LAYOUT: 'user/UPDATE_CUSTOMER_CHOICE_OF_APPS_LAYOUT',
  UIKITS_V4_POPUP: 'user/UIKITS_V4_POPUP',
  REGISTER_EMAIL: 'user/REGISTER_EMAIL',
  GET_CUSTOMER_CONTEXT: 'user/GET_CUSTOMER_CONTEXT',
  UPDATE_CUSTOMER_ON_DISPLAYING_KICKOFF_CALL_SCREEN:
    'user/UPDATE_CUSTOMER_ON_DISPLAYING_KICKOFF_CALL_SCREEN',
}

export default actions
